<modal-title
  class="modal-title-v2"
  [title]="'ProjectTeam.Manage.add' | translate"
  [closeCallback]="cancel.bind(this)"
/>

<form [formGroup]="form" class="project-team-manage">
  <p>{{ 'ProjectTeam.Manage.addDescription' | translate }}</p>
  <mat-dialog-content [ngClass]="{ 'project-team-manage--min-height': isMinHeight }">
    <ng-select
      ngSelectExtension
      #contactSearchSelect="ngSelectExtensionDir"
      [url]="Config.API + '/contact/search'"
      class="w-100 new-select mb-3"
      [placeholder]="('ProjectTeam.Manage.addTeamMembers' | translate) + '*'"
      [loadingText]="'ProjectTeam.Manage.loadingContacts' | translate"
      [notFoundText]="'ProjectTeam.Manage.notFoundContacts' | translate"
      [addTagText]="'ProjectTeam.Manage.addContact' | translate"
      [formControlName]="'user'"
      [bindLabel]="'fullName'"
      [responseTransform]="transformResponseToContacts.bind(this)"
      [hideSelected]="true"
      [multiple]="true"
      (change)="onUserSelectChange()"
      [closeOnSelect]="false"
      [addTag]="validateEmail.bind(this)"
      [tabIndex]="-1"
    >
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
        <contact-option-template [contact]="item" />
      </ng-template>
    </ng-select>

    <span
      *ngIf="form?.get('user')?.errors && !form?.get('user')?.value && form?.get('user')?.touched"
      class="d-flex form-control-error-msg mb-1"
      [innerHTML]="'ProjectTeam.noTeamMember' | translate"
    ></span>

    <div class="mb-3">
      <div class="new-select-label">{{ 'ProjectTeam.Manage.position' | translate }}</div>
      <input-v2
        class="text-control"
        formControlName="position"
        [errMessages]="errorMessages('position')"
        [placeholder]="'ProjectTeam.Manage.position' | translate"
      />
    </div>

    @if (isNecessaryToChoseRole) {
      <div class="mb-3">
        <div class="new-select-label">{{ 'ProjectTeam.Manage.role' | translate }}</div>
        <ng-select
          formControlName="role"
          [clearable]="false"
          [items]="positionSelectOptions"
          [bindLabel]="'text'"
          [bindValue]="'id'"
          [placeholder]="'ProjectTeam.Manage.role' | translate"
          class="new-select"
          appendTo="body"
        />
      </div>
    }

    <div class="mb-3" [permission]="{ group: PermissionsGroups.PROJECT_TEAM, action: 'HOURLY' }">
      <div class="new-select-label">{{ 'ProjectTeam.Manage.hourlyRate' | translate }}</div>
      <input-v2
        class="text-control"
        formControlName="hourlyRate"
        [errMessages]="errorMessages('hourlyRate')"
        [placeholder]="'ProjectTeam.Manage.hourlyRate' | translate"
      />
    </div>
  </mat-dialog-content>
</form>

<mat-dialog-actions align="end">
  <app-button
    (onClick)="cancel()"
    [class]="'mr-2 bold'"
    [config]="{
      text: 'ProjectTeam.Manage.cancel' | translate,
      type: ButtonTypes.NEW_SECONDARY_BLUE,
      size: ButtonSize.LARGE
    }"
  />
  <app-button
    [disabled]="loading"
    [loading]="loading"
    (onClick)="submit()"
    [config]="{
      text: 'ProjectTeam.Manage.invite' | translate,
      type: ButtonTypes.NEW_PRIMARY_BLUE,
      size: ButtonSize.LARGE,
      prependSrc: './assets/img/ic-plus-add.svg'
    }"
  />
</mat-dialog-actions>
